export const themes = ["red", "orange", "blue"];
